<template>
  <div class="big">
    <div class="page_title">注销列表(患)</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="searchbox">
          <span>用户昵称</span>
          <el-input
            v-model="nick_name"
            style="width: 130px; margin: 0 10px"
            clearable
            @change="search"
          ></el-input>
          <span>手机号</span>
          <el-input
            v-model="phone"
            style="width: 130px; margin: 0 10px"
            clearable
            @change="search"
          ></el-input>
          <span>提交时间</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 225px; margin: 0 10px"
            @change="search"
          >
          </el-date-picker>
          <span>身份证号</span>
          <el-input
            v-model="id_card"
            style="width: 130px; margin: 0 10px"
            clearable
            @change="search"
          ></el-input>
          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981"
            @click="search"
          >查询</el-button>
          <span>
            <span style="margin: 0 10px 0 15px">注销结果</span>
            <el-radio-group
              v-model="status"
              @change="search"
            >
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">待审核</el-radio>
              <el-radio :label="2">已注销</el-radio>
              <el-radio :label="3">已驳回</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="create_time"
              label="提交时间"
            ></el-table-column>
            <el-table-column
              prop="nick_name"
              label="用户昵称"
            >
            </el-table-column>
            <el-table-column
              prop="id_card"
              label="身份证号"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
            ></el-table-column>

            <el-table-column label="注销结果">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">待审核</span>
                <span v-if="scope.row.status == 2">已注销</span>
                <span v-if="scope.row.status == 3">已驳回</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="examine_time"
              label="操作时间"
            ></el-table-column>
            <el-table-column label="操作">
              <template
                slot-scope="scope"
                v-if="scope.row.status == 1"
              >
                <el-button
                  @click="showCancelDia(scope.row.user_id)"
                  type="text"
                  size="medium"
                  :disabled="
                  module_id_array[0] ? !module_id_array.includes('884') : false
                "
                >注销</el-button>
                <el-button
                  @click="refuse(scope.row.cancel_id)"
                  type="text"
                  size="medium"
                  :disabled="
                  module_id_array[0] ? !module_id_array.includes('931') : false
                "
                >驳回</el-button>

              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 注销弹窗 -->
    <el-dialog
      title="提 示"
      :visible.sync="cancelDia"
      width="700px"
      :close-on-click-modal="false"
    >
      <div class="content">
        <div style="color:#FF7200;">
          注意：注销账户前，需核实用户问诊、订单、账户等情况。
        </div>
        <div>
          <div class="box">
            <div class="item">
              <div class="title">● 问诊记录</div>
              <div style="padding-left:12px">
                <span>待确认</span>
                <span
                  style="margin:0 30px 0 10px">{{statistics_info.to_be_confirmed_consult_count}}条</span>
                <span>咨询中</span>
                <span style="margin-left:10px">{{statistics_info.consulting_consult_count}}条</span>
              </div>
            </div>
            <div class="item">
              <div class="title">● 预约问诊记录</div>
              <div style="padding-left:12px">
                <span>待确认</span>
                <span
                  style="margin-left:10px">{{statistics_info.to_be_confirmed_register_count}}条</span>
              </div>
            </div>
            <div class="item">
              <div class="title">● 处方订单</div>
              <div style="padding-left:12px">
                <span>待发货</span>
                <span
                  style="margin:0 30px 0 10px">{{statistics_info.to_be_shipped_prescription_count}}条</span>
                <span>待收货</span>
                <span
                  style="margin-left:10px">{{statistics_info.goods_to_be_received_prescription_count}}条</span>
              </div>
            </div>
            <div class="item">
              <div class="title">● 商城订单</div>
              <div style="padding-left:12px">
                <span>待发货</span>
                <span
                  style="margin:0 30px 0 10px">{{statistics_info.to_be_shipped_order_count}}条</span>
                <span>待收货</span>
                <span
                  style="margin:0 30px 0 10px">{{statistics_info.goods_to_be_received_order_count}}条</span>
              </div>
            </div>
          </div>
          <div class="box">
            <div class="item">
              <div class="title">● 用户积分</div>
              <div class="pricebox">
                <div class="priceitem">
                  <div class="num red">{{integral_info.integral}}</div>
                  <div class="gray">当前积分</div>
                </div>
                <div class="priceitem">
                  <div class="num">{{integral_info.use_integral}}</div>
                  <div class="gray">已用积分</div>
                </div>
                <div class="priceitem">
                  <div class="num">{{integral_info.expire_integral}}</div>
                  <div class="gray">失效积分</div>
                </div>
              </div>
            </div>
          </div>
          <div class="green">
            是否分销员
            <span>{{is_staff?"是":"否"}}</span>
          </div>
          <div
            class="box"
            v-if="is_staff"
          >
            <div class="pricebox">
              <div class="priceitem">
                <div class="num red">{{commission_info.settled_money}}</div>
                <div class="gray">待结算佣金</div>
              </div>
              <div class="priceitem">
                <div class="num">{{commission_info.commission_total_price}}</div>
                <div class="gray">累计佣金</div>
              </div>
              <div class="priceitem">
                <div class="num">{{commission_info.pay_money}}</div>
                <div class="gray">累计提现</div>
              </div>
              <div class="priceitem">
                <div class="num red">{{commission_info.settle_money}}</div>
                <div class="gray">余额</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: center; padding-bottom: 20px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            plain
            @click="cancelDia = false"
            style="width: 92px"
            size="medium"
          >取消操作 </el-button>
          <el-button
            type="primary"
            @click="cancelUser"
            style="width: 92px"
            size="medium"
          >确认注销</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      nick_name: '',
      phone: '',
      id_card: '',
      status: 0,
      date: [],
      cancelDia: false,
      is_staff: false,
      commission_info: {},
      statistics_info: {},
      integral_info: {},
      user_id: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        nick_name: this.nick_name,
        phone: this.phone,
        id_card: this.id_card,
        status: this.status
      };
      if (this.date && this.date.length > 0) {
        data.date_time_start = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.date_time_end = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios.post('platform/patient/getUserCancelLog', data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format('YYYY-MM-DD HH:mm');
            item.examine_time = item.examine_time
              ? dayjs.unix(item.examine_time).format('YYYY-MM-DD HH:mm')
              : '';
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //注销用户弹窗
    showCancelDia(user_id) {
      this.user_id = user_id;
      this.axios
        .post('platform/patient/getUserCurrentAccountNumber', { user_id })
        .then((res) => {
          this.statistics_info = res.data.statistics_info;
          this.is_staff = res.data.commission_info == true ? true : false;
          this.commission_info = res.data.commission_info;
          this.integral_info = res.data.integral_info
            ? res.data.integral_info
            : {};
          this.cancelDia = true;
        });
    },
    //注销用户
    cancelUser() {
      let user_id = this.user_id;
      this.axios
        .post('platform/patient/saveUserItemOpenId', { user_id })
        .then((res) => {
          this.$message.success('该用户账号已注销');
          this.getList();
          this.cancelDia = false;
        });
    },
    //驳回申请
    refuse(cancel_id) {
      this.$confirm('确定驳回申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/patient/rejectUserCancel', { cancel_id })
            .then((res) => {
              this.$message.success('申请已驳回,用户可重新再提交注销申请');
              this.getList();
            });
        })
        .catch(() => {});
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}
.content {
  padding: 20px;
  text-align: left;
  .box {
    background: #f5f5f5;
    margin-top: 8px;
    padding: 10px;
  }
  .green {
    color: #669961;
    font-weight: 700;
    margin-top: 20px;
  }
  .title {
    font-weight: 700;
    margin-bottom: 6px;
  }
  .item {
    margin-bottom: 14px;
    &:last-child {
      margin-bottom: 6px;
    }
  }
  .pricebox {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    .priceitem {
      text-align: center;
      padding: 0 30px;
      border-right: solid 1px #d6d6d6;
    }
    .priceitem:before {
      content: '';
    }
    .gray {
      font-size: 12px;
      color: #747981;
      display: inline-block;
      margin-top: 6px;
    }
    .num {
      font-size: 18px;
      font-weight: 600;
    }
    .red {
      color: #f24e33;
    }
  }
}
</style>
